'use client';

import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import P from '@/components/typography/p';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export default function Impact() {
    const { t } = useTranslation();
    const sections = t('impact', { returnObjects: true }) as {
        title: string;
        text: string;
    }[];

    return (
        <>
            <div className="mt-[3.5rem] mb-[4rem] flex flex-col gap-[2.5rem] lg:mx-auto lg:mt-[5rem] lg:mb-[14rem] xl:w-[90rem] 2xl:w-[100rem]">
                {sections.map((section, index) => (
                    <div
                        key={index}
                        className={cn(
                            'px-5 lg:w-[50.5rem]',
                            index === 0 && 'xl:mr-[9.5rem] xl:ml-auto',
                        )}
                    >
                        <H3 className="mb-[1.25rem]">{section.title}</H3>
                        <P dangerouslySetInnerHTML={{ __html: section.text }} />
                    </div>
                ))}
                <div className="overflow-auto px-5 lg:mb-[10rem]">
                    <div className="border-primary flex items-center justify-between gap-4 rounded-lg border px-4 py-3 sm:max-w-[19rem] lg:w-fit lg:max-w-[32rem] lg:justify-center lg:gap-4 lg:py-4">
                        <Label variant="default">
                            Download hier ons impact{' '}
                            <br className="hidden lg:block" />
                            rapport 2024
                        </Label>
                        <Link
                            href="/download/food-cabinet-impact-report-2024.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button className="lg:px-8">
                                <Label variant="button" className="underline">
                                    Download
                                </Label>
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <Image
                    src="/images/stickers/report.png"
                    alt="Impact Image"
                    className="absolute right-[-4rem] bottom-[0rem] h-auto w-[350px] object-cover lg:right-[-6rem] lg:bottom-[19rem] lg:w-[400px] xl:w-[500px]"
                    width={700}
                    height={300}
                />
            </div>
        </>
    );
}
